import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/pages/Home";
import AboutUs from "./components/pages/AboutUs";
import Resources from "./components/pages/Resources";
import ResourceItemPage from "./components/pages/ResourceItemPage";
import News from "./components/pages/News";
import NewsItemPage from "./components/pages/NewsItemPage";
import WhatWeDo from "./components/pages/WhatWeDo";
import NotFound from "./components/NotFound";
import WhatIsStatelessness from "./components/pages/WhatIsStatelessness";
import FocusAreaItemPage from "./components/pages/FocusAreaItemPage";
import Page from "./components/pages/Page";
import ProjectItemPage from "./components/pages/ProjectItemPage";
import Courses from "./components/pages/Courses";
import PublicationItemPage from "./components/pages/PublicationItemPage";
import AdvocacyWorkItemPage from "./components/pages/AdvocacyWorkItemPage";
import Conference from "./components/pages/Conference";
import RedirectComponent from "./components/Redirect";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import YearOfAction from "./components/pages/YearOfAction";
import EventItemPage from "./components/pages/EventItemPage";
import YearOfActionResourceItemPage from "./components/pages/YearOfActionResourceItemPage";

class App extends Component {
  render() {
    return (
      <div className="app">
        <Navigation />

        <div className="content">
          <Router>
            <Switch>
              <Route
                exact
                path="/"
                render={routeProps => (
                  <Home {...routeProps} prismicCtx={this.props.prismicCtx} />
                )}
              />
              <Route
                exact
                path="/focus-areas/:uid"
                render={routeProps => (
                  <FocusAreaItemPage
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/about-us"
                render={routeProps => (
                  <AboutUs {...routeProps} prismicCtx={this.props.prismicCtx} />
                )}
              />
              <Route
                exact
                path="/what-is-statelessness"
                render={routeProps => (
                  <WhatIsStatelessness
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/resources"
                render={routeProps => (
                  <Resources
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/resources/:uid"
                render={routeProps => (
                  <ResourceItemPage
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/news"
                render={routeProps => (
                  <News {...routeProps} prismicCtx={this.props.prismicCtx} />
                )}
              />
              <Route
                exact
                path="/news/:uid"
                render={routeProps => (
                  <NewsItemPage
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/what-we-do"
                render={routeProps => (
                  <WhatWeDo
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/core-activities/:uid"
                render={routeProps => (
                  <ProjectItemPage
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/projects/:uid"
                render={routeProps => (
                  <PublicationItemPage
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/raising-awareness/:uid"
                render={routeProps => (
                  <AdvocacyWorkItemPage
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/courses"
                render={routeProps => (
                  <Courses {...routeProps} prismicCtx={this.props.prismicCtx} />
                )}
              />
              <Route
                exact
                path="/conference"
                render={routeProps => (
                  <Conference
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />
              <Route
                exact
                path="/year-of-action"
                render={routeProps => <YearOfAction {...routeProps} />}
              />
              <Route
                exact
                path="/events/:uid"
                render={routeProps => <EventItemPage {...routeProps} />}
              />
              <Route
                exact
                path="/year-of-action-resources/:uid"
                render={routeProps => (
                  <YearOfActionResourceItemPage {...routeProps} />
                )}
              />
              <Route
                exact
                path="/pages/:uid"
                render={routeProps => (
                  <Page {...routeProps} prismicCtx={this.props.prismicCtx} />
                )}
              />
              <Route
                exact
                path="/:uid"
                render={routeProps => (
                  <RedirectComponent
                    {...routeProps}
                    prismicCtx={this.props.prismicCtx}
                  />
                )}
              />

              <Route component={NotFound} />
            </Switch>
          </Router>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js